/* eslint-disable */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { assetImages } from "constants";

const CommunityHeader = ({ setfilterQuery, refreshHandler }) => {
  const token = localStorage.getItem("token");

  const [queryText, setQueryText] = useState("");

  const searchHandler = () => {
    setfilterQuery(queryText);
    setQueryText("");
  };

  return (
    <div className="forum_search_row d-flex align-items-center gap-2 justify-content-between mb-4">
      <div className="forum_search">
        <input
          type="text"
          className="form-control"
          placeholder="Search"
          value={queryText}
          onChange={(e) => setQueryText(e.target.value)}
        />
        <button className="forum_search_query_btn" onClick={searchHandler}>
          {" "}
          <span className="material-icons-outlined fs-lg text-primary">
            search
          </span>
        </button>
      </div>
      <div className="search_right d-flex gap-2 align-items-center">
        <div className="ask_btn">
          <Link
            to="#"
            className="btn primary-btn"
            data-bs-toggle="modal"
            data-bs-target={token ? "#question_modal" : "#login_modal"}
          >
            <span>Ask or Share Question</span>
          </Link>
        </div>

        <div className="forum_filter ms-auto">
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary"
            // data-bs-toggle="offcanvas"
            // data-bs-target="#offcanvasRight"
            onClick={refreshHandler}
          >
            <span className="material-icons-outlined text-white">refresh</span>
          </Link>
        </div>

        <div className="forum_filter">
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
          >
            <span className="material-icons-outlined text-white">
              filter_list
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CommunityHeader;
